import Layout from 'antd/lib/layout/layout';
import React from 'react'
import MySider from './Sider';
import MyNavbar from './Navbar';

export default function AppLayout({menuItems}) {
    const [sidebarCollapsed, setSidebarCollapsed] = React.useState(false);

    return (
        <Layout hasSider >
            <MySider 
                collapsed={sidebarCollapsed}
                onCollapse={() => setSidebarCollapsed(!sidebarCollapsed)}
                menuItems={menuItems}
            />
            <Layout>
                <MyNavbar
                    collapsed={sidebarCollapsed}
                    onCollapse={() => setSidebarCollapsed(!sidebarCollapsed)}
                    // globalSearchItems={globalSearchItems}
                />
            </Layout>
        </Layout>
    )
}
